export default __webpack_public_path__ + "static/media/numbers-tablet.0e401914.jpg";